.watchlistDropdown {
  [data-dropdown-list] {
    width: 288px;
    overflow: auto;
    max-height: 264px;
  }
}

.dropdownDivider {
  border: 1px solid var(--border-soft);
  margin: 4px 0;
}

.itemRow {
  padding: 8px;
}

.dropdownCheckbox {
  label {
    width: 100%;
  }
}

.loadingWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
}
